import AnimMediaControl from './anim-media-control';
import type { IMediaParams } from '@src/slide/application/service/media-manager/params.interface';
import { MediaRegion, type IMediaManager } from '@src/slide/application/service/media-manager/media-manager.interface';

export default class EditorAnimAudioControl extends AnimMediaControl {
    public static instance: EditorAnimAudioControl;
    public static getInstance(mediaManager: IMediaManager): EditorAnimAudioControl {
        if (!this.instance) {
            this.instance = new EditorAnimAudioControl(mediaManager);
        }
        return this.instance;
    }

    public completeMediaControl(mediaParams: IMediaParams): void | undefined {
        this.mediaManager.resetAudioByRegion(mediaParams.elementModel.key, MediaRegion.EDITOR);
    }

    public isPlaying(): boolean {
        const audio = this.mediaManager.getAudioInstanceByRegion(this.elementModel?.key, MediaRegion.EDITOR);
        if (!audio) {
            return false;
        }
        return !audio.paused;
    }

    // media开始播放
    protected playHandler(): void {
        this.mediaManager.playAudioByRegion(this.elementModel?.key, MediaRegion.EDITOR);
    }

    // 预览态下tooglePause的行为: 始终从头播放
    protected togglePauseHandler(): void {
        this.playHandler();
    }

    //  media停止播放
    protected stopHandler(): void {
        this.mediaManager.resetAudioByRegion(this.elementModel?.key, MediaRegion.EDITOR);
    }

    /**
     * 获取Audio元素
     * @returns Audio dom元素
     */
    protected getMediaInstance(elementModelKey: string): HTMLAudioElement {
        return this.mediaManager?.getAudioInstanceByRegion(elementModelKey, MediaRegion.EDITOR) as HTMLAudioElement;
    }
}
